import { z } from "zod";
import { GenericFoodSchema } from "./FoodSchema";
export const AusnutFoodSchema = GenericFoodSchema.merge(z.object({
    source: z.literal("ausnut"),
    ausnutId: z.string(),
    ausnutName: z.string(),
}));
//# sourceMappingURL=AusnutFoodSchema.js.map